import React, { useCallback, useEffect, useRef, useState } from "react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

type Alumni = {
  youtube: string;
  name: string;
  img: string;
  description: string;
  des: string;
  compLogo: string;
  alliance: string;
  location: string;
  alt: string;
  linkdin: string;
};

const UspAlumniDesktop: React.FC = () => {
  const autoplayRef = useRef(
    Autoplay({
      delay: 2000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      stopOnFocusIn: false,
    }),
  );
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      skipSnaps: false,
      breakpoints: {
        "(min-width: 768px)": { slidesToScroll: 1 },
        "(min-width: 1024px)": { slidesToScroll: 1 },
      },
    },
    [autoplayRef.current],
  );

  useEffect(() => {
    if (emblaApi) {
      emblaApi.reInit();
      if (autoplayRef.current) {
        autoplayRef.current.reset();
      }
    }
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi && autoplayRef.current) {
      autoplayRef.current.play();
    }
  }, [emblaApi]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) {
      emblaApi.scrollPrev();
      if (autoplayRef.current) {
        autoplayRef.current.reset();
      }
    }
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) {
      emblaApi.scrollNext();
      if (autoplayRef.current) {
        autoplayRef.current.reset();
      }
    }
  }, [emblaApi]);

  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });
  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  const cardData: Alumni[] = [
    {
      name: "Vijay Reddy",
      img: "/accounting/al1.png",
      alt: "vijay reddy, accounting alumni - miles education",
      description:
        "With Miles by my side, I turned my dream of a US accounting career into a thriving reality. Their expertise made all the difference in my success.",
      des: "With Miles by my side, I turned my dream of a US accounting career into a thriving reality. Their expertise made all the difference in my success.",
      compLogo: "/accounting/fl.png",
      alliance: "BDO Alliance",
      location: "Redlands, CA",
      linkdin: "https://www.linkedin.com/in/vijaynrkonduru/",
      youtube: "https://youtube.com/shorts/He2cwbYxp44?feature=share",
    },
    {
      name: "Hyder Syed",
      img: "/accounting/al2.jpeg",
      alt: "hyder sayed, accounting alumni - miles education",
      description:
        "Choosing the Miles US Pathway was a smart move. Thanks to Miles Placement Team for guiding me through it. I've embraced, conquered, and now I'm ready to fly! ",
      des: "Choosing the Miles US Pathway was a smart move. Thanks to Miles Placement Team for guiding me through it. I've embraced, conquered, and now I'm ready to fly! ",
      compLogo: "/newImages/MilesEducationWebsite-2024/MBE_Logo.png",
      alliance: "BDO Alliance",
      location: "Chandler, AZ",
      linkdin: "http://linkedin.com/in/hyder-syed",
      youtube: "https://youtube.com/shorts/myS4Ic_FfA0?feature=share",
    },
    {
      name: "Manisha Kulkarni ",
      img: "/accounting/al3.webp",
      alt: "manisha kulkarni, accounting alumni - miles education",
      description:
        "Miles helped me master my field and turn my American Dream into reality by securing my placement in the US. Grateful for their expertise and support.",
      des: "Miles helped me master my field and turn my American Dream into reality by securing my placement in the US. Grateful for their expertise and support.",

      compLogo: "/newImages/MilesEducationWebsite-2024/rsm.png",
      alliance: "BDO Alliance",
      location: "Philadelphia, PA",
      linkdin: "https://www.linkedin.com/in/manisha-kulkarni-060634187/",
      youtube: "https://youtube.com/shorts/vcNGtncehYY?feature=share",
    },
    {
      name: "Anand Sharma",
      img: "/accounting/al4.webp",
      alt: "anand sharma, accounting alumni - miles education",
      description:
        "The Miles US Pathway program was a game-changer for my career growth. Massive thanks to the Miles Placement team for their invaluable support and guidance throughout!",
      des: "The Miles US Pathway program was a game-changer for my career growth. Massive thanks to the Miles Placement team for their invaluable support and guidance throughout!",

      compLogo: "/accounting/ksdt.png",
      location: "Miami, FL ",
      alliance: "BDO Alliance",
      linkdin: "https://in.linkedin.com/in/anand-sharma-080b0314a",
      youtube: "https://youtube.com/shorts/NbKbS-2Nv1o?feature=share",
    },

    {
      name: "Lavika Sharma",
      img: "/newImages/MilesEducationWebsite-2024/alumni/Lavika.png",
      alt: "lavika sharma, accounting alumni - miles education",
      description:
        "Thanks to Miles, my US work dream is now a reality! Ready for the next career chapter with a bag full of wins waiting. ",
      des: "Thanks to Miles, my US work dream is now a reality! Ready for the next career chapter with a bag full of wins waiting.  ",

      compLogo: "/newImages/MilesEducationWebsite-2024/alumni/logo1.png",
      location: " Minneapolis, MN",
      alliance: "Allinial Alliance",
      linkdin: "https://www.linkedin.com/in/lavika-sharma-6b9703165/",
      youtube: "https://youtube.com/shorts/_Fz6_qI0IK8?feature=share",
    },
    {
      name: "Disha Rungta",
      img: "/accounting/al7.webp",
      alt: "disha rungta, accounting alumni - miles education",
      description:
        "Thanks to Miles, I'm diving into a thrilling new chapter in the US. This transition is huge for me, and I'm excited for what's next!",
      des: "Thanks to Miles, I'm diving into a thrilling new chapter in the US. This transition is huge for me, and I'm excited for what's next!",

      compLogo: "/newImages/MilesEducationWebsite-2024/rsm.png",
      location: "New York City, NY",
      alliance: "  Alliance",
      linkdin:
        "https://www.linkedin.com/in/disha-rungta?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      youtube: "https://youtube.com/shorts/UTdmgdGxGug?feature=share",
    },
    {
      name: "Vinay Kumar",
      img: "/accounting/al8.jpg",
      alt: "vinay kumar, accounting alumni - miles education",
      description:
        "With Miles it was a smooth journey of not just all round support and improvement but also elevating my confidence in myself in achieving my dream.",
      des: "With Miles it was a smooth journey of not just all round support and improvement but also elevating my confidence in myself in achieving my dream.",

      compLogo: "/accounting/lg4.png",
      location: "Chapel Hill, NC",
      alliance: "RSM Alliance",
      linkdin: "http://linkedin.com/in/402581189",
      youtube: "https://www.youtube.com/shorts/z-cwdKrwqN4",
    },
    {
      name: "Vamshi Teja",
      img: "/accounting/al9.jpeg",
      alt: "vamshi teja, accounting alumni - miles education",
      description:
        "Moving to the US has been a transformative journey. Thanks to Miles, I’ve had an incredible year and am thrilled to begin my new job!",
      des: "Moving to the US has been a transformative journey. Thanks to Miles, I’ve had an incredible year and am thrilled to begin my new job!",

      compLogo: "/accounting/fl.png",
      location: "Redlands, CA",
      alliance: "RSM Alliance",
      linkdin: "https://www.linkedin.com/in/vamshi-teja-vangala-604081141/",
      youtube: "https://youtube.com/shorts/e9UwNPzHG2Q?feature=share",
    },
  ];

  return (
    <>
      <div className="w-full md:pt-[2px] pt-[22px] md:pb-[0px] pb-[32px] justify-center bg-[#0C1F33] relative">
        <Image
          src="/usp/m-1.png"
          alt="Accountants "
          className="cursor-pointer absolute bottom-0 left-0 z-[0]"
          width={640}
          height={460}
          loading="lazy"
        />
        <div
          className="lg:container mx-auto  h-full 2xl:px-0 xl:px-12 lg:px-6 px_5 relative lg:block hidden"
          id="alumni2"
        >
          <div
            className="lg:pb-20 lg:pt-12 md:py-6 md:pb-10 lg:px-0 md:px-5 px-3 pt-5 pb-14"
            id="how"
          >
            <div className="text-center">
              <h2 className="lg:text-[36px] md:text-[36px] mb-3 font-semibold text-white text-center leading-normal inline-block mx-auto px-[4px]">
                <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                  Miles alumni in the US
                </span>
              </h2>
              <div className="mt-6 flex justify-center">
                <div
                  className="relative cursor-pointer z-50"
                  style={{ width: "960px", height: "506px" }}
                  onClick={() => {
                    openPopup("WCHY6bvBTxM");
                  }}
                >
                  {" "}
                  <Image
                    src="/usp/akash-usp.png"
                    alt="Accountants"
                    className="cursor-pointer w-[1052px] h-[475px] rounded-[8px]"
                    width={490}
                    height={285}
                  />
                </div>
              </div>
            </div>
            <div className="flex 2xl:justify-between  md:justify-between  flex-nowrap overflow-y-auto md:mt-0 mt-[-200px]">
              <div className="embla overflow-hidden w-full" ref={emblaRef}>
                <div
                  className="embla__container flex"
                  style={{
                    backfaceVisibility: "hidden",
                    transform: "translate3d(0, 0, 0)",
                  }}
                >
                  {cardData.map((data, i) => (
                    <div
                      key={"cpa-slide" + i}
                      className="embla__slide flex-[0_0_auto] flex-shrink-0"
                      style={{
                        minWidth: "280px",
                        marginRight: "20px",
                      }}
                    >
                      <div
                        key={"cpa-land-" + i}
                        className="2xl:w-[18%] xl:w-[14%] lg:w-[14%] poppins_regular 2xl:min-w-[243px] xl:min-w-[280px] gap-5 h-[340px] lg:min-w-[213px] md:min-w-[243px] min-w-[265px] bg-white  xl:mx-[0px] rounded-[15px] lg:mt-[6rem] mt-[4rem] border-2 mx-auto relative"
                      >
                        <a href={data.linkdin} target="_blank">
                          <div className="px-[15px] pb-[15px]">
                            <Image
                              src={data.img}
                              alt={data.alt}
                              className="w-auto lg:max-w-full mx-auto absolute plane_img top-0 rounded-full alumni_img object-contain"
                              width={105}
                              height={33}
                              priority
                            />
                            <div className="flex justify-center mb-3 items-center mt-16">
                              <p className="mr-[4px] font-semibold  text-[16px] text-center text-[#0C1F33] leading-normal">
                                {data.name}
                              </p>
                              <img
                                style={{ width: "20px" }}
                                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/lin.webp"
                                alt="linkedin icon"
                              />
                            </div>
                            <p className="mt-3 !text-center font-medium md:text-[16px] text-ccc md:px-[0px] px-[5px] text-[#535353] line-clamp-4 max-w-[220px] leading-5 tracking-[-0.16px]">
                              {data.des}
                              <br />
                            </p>
                          </div>
                          <div className="px-[11px]  text-center">
                            <Image
                              src={data.compLogo}
                              alt="Special Offer"
                              className="mx-auto my-2 h-[26px]"
                              width={80}
                              height={30}
                              priority
                            />
                          </div>
                        </a>
                        <p className="text-center text-[14px] font-medium text-black">
                          {data.location}
                        </p>
                        <div className="flex justify-center pt-3">
                          <a
                            href={data.youtube || "#"}
                            target="_blank"
                            className="inline-block text-[14px] font-medium text-[#535353] bg-[#E9E9E9] rounded-[18px] px-2 story_shadow"
                          >
                            <img
                              src="/yt.png"
                              alt="YouTube Icon"
                              className="inline-block mr-2 w-[30px] h-[30px]"
                            />
                            Watch my story
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div
            onClick={() => scrollPrev()}
            className="absolute 2xl:left-[-50px] xl:left-[-5px] lg:left-[5px] left-[0px] top-[78%] cursor-pointer"
          >
            <Image
              src="/cpa/arrow.png"
              alt="arrow image"
              className="mx-auto my-2 xl:w-[43px] md:w-[28px] rotate-180 relative"
              width={43}
              height={43}
              priority
            />
          </div>
          <div
            onClick={() => scrollNext()}
            className="absolute 2xl:right-[-50px] xl:right-[5px] lg:right-[5px] right-[0px] top-[78%] cursor-pointer"
          >
            <Image
              src="/cpa/arrow.png"
              alt="arrow image"
              className="mx-auto my-2 xl:w-[43px] md:w-[28px] relative"
              width={43}
              height={43}
              priority
            />
          </div>
        </div>
        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                id="huge-shortage-video-player"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspAlumniDesktop;
